module.exports = __webpack_public_path__ + "img/camera_project_equirect_icon.55cd1a9d.png";